/**
 * Defines the values to use for specifying path-drawing commands.
 * The values in this class are used by the Graphics.drawPath() method,
 *or stored in the commands vector of a GraphicsPath object.
 */
export var GraphicsPathCommand;
(function (GraphicsPathCommand) {
    /**
     * Represents the default "do nothing" command.
     */
    GraphicsPathCommand[GraphicsPathCommand["NO_OP"] = 0] = "NO_OP";
    /**
     * Specifies a drawing command that moves the current drawing position
     * to the x- and y-coordinates specified in the data vector.
     */
    GraphicsPathCommand[GraphicsPathCommand["MOVE_TO"] = 1] = "MOVE_TO";
    /**
     * Specifies a drawing command that draws a line from the current drawing position
     * to the x- and y-coordinates specified in the data vector.
     */
    GraphicsPathCommand[GraphicsPathCommand["LINE_TO"] = 2] = "LINE_TO";
    /**
     *  Specifies a drawing command that draws a curve from the current drawing position
     *  to the x- and y-coordinates specified in the data vector, using a control point.
     */
    GraphicsPathCommand[GraphicsPathCommand["CURVE_TO"] = 3] = "CURVE_TO";
    /**
     *  Specifies a drawing command that draws a curve from the current drawing position
     *  to the x- and y-coordinates specified in the data vector, using a control point.
     */
    GraphicsPathCommand[GraphicsPathCommand["BUILD_JOINT"] = 13] = "BUILD_JOINT";
    GraphicsPathCommand[GraphicsPathCommand["BUILD_ROUND_JOINT"] = 14] = "BUILD_ROUND_JOINT";
    /**
     * Specifies a "line to" drawing command,
     * but uses two sets of coordinates (four values) instead of one set.
     */
    GraphicsPathCommand[GraphicsPathCommand["WIDE_LINE_TO"] = 4] = "WIDE_LINE_TO";
    /**
     *   Specifies a "move to" drawing command,
     *   but uses two sets of coordinates (four values) instead of one set.
     */
    GraphicsPathCommand[GraphicsPathCommand["WIDE_MOVE_TO"] = 5] = "WIDE_MOVE_TO";
    /**
     * Specifies a drawing command that draws a curve from the current drawing position
     * to the x- and y-coordinates specified in the data vector, using 2 control points.
     */
    GraphicsPathCommand[GraphicsPathCommand["CUBIC_CURVE"] = 6] = "CUBIC_CURVE";
})(GraphicsPathCommand || (GraphicsPathCommand = {}));
